<script setup>
import { computed } from 'vue';

const props = defineProps({
  isActive: { type: Boolean, default: false },
  size: { type: String, default: 'md' },
  asChild: { type: Boolean, default: false },
});

const buttonClasses = computed(() => {
  // Quand asChild est utilisé, ne pas appliquer de background ni de hover car ils seront gérés par le composant enfant
  const base = props.asChild
    ? 'flex min-h-[36px] w-full min-w-0 items-center gap-2.5 text-n-sidebar-text outline-none ring-sidebar-ring focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 group-data-[collapsible=icon]:hidden transition-all duration-200 [&_svg]:text-n-sidebar-indicator'
    : 'flex min-h-[36px] w-full min-w-0 items-center gap-2.5 overflow-hidden rounded-md px-3.5 py-1.5 text-n-sidebar-text outline-none ring-sidebar-ring hover:bg-n-sidebar-item-hover hover:text-n-sidebar-text focus-visible:ring-2 active:bg-n-sidebar-item-hover active:text-n-sidebar-text disabled:pointer-events-none disabled:opacity-50 group-data-[collapsible=icon]:hidden transition-all duration-200 cursor-pointer [&_svg]:text-n-sidebar-indicator';

  const sizeClasses = {
    sm: 'text-[13px]',
    md: 'text-[15px]',
  };

  // Ne pas appliquer de background quand asChild est utilisé car il sera géré par le composant enfant
  const activeClass =
    props.isActive && !props.asChild
      ? 'bg-n-sidebar-subitem-active text-n-sidebar-text font-medium hover:!bg-n-sidebar-item-active-hover hover:!text-n-sidebar-text'
      : '';

  return `${base} ${sizeClasses[props.size]} ${activeClass}`;
});
</script>

<template>
  <component
    :is="asChild ? 'div' : 'a'"
    data-sidebar="menu-sub-button"
    :data-size="size"
    :data-active="isActive"
    :class="buttonClasses"
  >
    <slot />
  </component>
</template>
